import { DfaLogoBig, DfaLogo, DfaLogoCompact } from './Logo';
import classNames from './index.module.scss';


export const dfa = {
    logo: {
        Normal: DfaLogoBig,
        Small: DfaLogo,
        Compact: DfaLogoCompact,
    },
    classNames,
};
